import React from 'react';
import { connect } from 'react-redux';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';

import { baseMapStateToProps } from '../componentBase';
import { PageTitle } from '../pages/pageTitle';
import { ClippingPlatformState } from '../../store/clippingPlatformState';
import { getAfterEffectsClipTemplates } from '../../api/clipGenV2/afterEffectsTemplates.actions';
import { getAfterEffectsMusicFiles, getAfterEffectsInstitutions } from '../../api/clipGenV2/afterEffectsMusic.actions';
import { getAzureSas } from '../../api/clipGenV2/azureSas.actions';

import { callApi } from 'helpers/callApi/callApi';
import { ParticipantManagementContainer } from './participants/participantManagementContainer';
import { TemplateManagementContainer } from './templates/templateManagementContainer';
import { JobManagementContainer } from './jobs/jobManagementContainer';
import { MusicManagementContainer } from './music/musicManagementContainer';
import { ClipGeneratorPageProps, ClipGeneratorPageState } from './ClipGeneratorPage.types';
import styles from './ClipGeneratorPage.module.scss';
import { ChapterManagementContainer } from './chapters/chapterManagementContainer';

class ClipGeneratorPage extends React.Component<ClipGeneratorPageProps, ClipGeneratorPageState> {
  state: ClipGeneratorPageState = {
    templates: [],
    getTemplatesLoading: false,
    getTemplatesError: false,
    music: [],
    getMusicLoading: false,
    getInstituteLoading: false,
    getMusicError: false,
    institutes: [],
  };

  componentDidMount() {
    this.getTemplates();
    this.getMusic();
    this.getInstitutes();
  }

  getTemplates = () => {
    const { getAfterEffectsTemplates } = this.props;

    callApi({
      action: () => {
        this.setState({ getTemplatesLoading: true });

        return getAfterEffectsTemplates();
      },
      onSuccess: ({ payload }) => {
        this.setState({ templates: payload, getTemplatesLoading: false, getTemplatesError: false });
      },
      onFailure: () => this.setState({ templates: null, getTemplatesLoading: false, getTemplatesError: true }),
    });
  };

  getMusic = () => {
    const { getAfterEffectsMusic } = this.props;

    callApi({
      action: () => {
        this.setState({ getMusicLoading: true });

        return getAfterEffectsMusic();
      },
      onSuccess: ({ payload }) => {
        this.setState({ music: payload, getMusicLoading: false, getMusicError: false });
      },
      onFailure: () => this.setState({ music: [], getMusicLoading: false, getMusicError: true }),
    });
  };

  getInstitutes = () => {
    const { getInstitutes } = this.props;

    callApi({
      action: () => {
        this.setState({ getInstituteLoading: true });

        return getInstitutes();
      },
      onSuccess: ({ payload }) => {
        this.setState({ institutes: payload.rows, getInstituteLoading: false, getMusicError: false });
      },
      onFailure: () => this.setState({ institutes: [], getInstituteLoading: false, getMusicError: true }),
    });
  };

  render = () => {
    const {
      templates,
      getTemplatesLoading,
      getTemplatesError,
      music,
      getMusicLoading,
      getInstituteLoading,
      getMusicError,
      institutes,
    } = this.state;

    return (
      <>
        <div className={styles.warning}>THIS PAGE IS FOR TEST PURPOSES ONLY AND SHOULD NOT BE USED IN PRODUCTION</div>
        <PageTitle displayTitle="Clip Generator" />
        <Tabs>
          <TabList>
            <Tab>Templates</Tab>
            <Tab>Music</Tab>
            <Tab>Participants</Tab>
            <Tab>Chapters</Tab>
            <Tab>Jobs</Tab>
          </TabList>
          <TabPanel>
            <TemplateManagementContainer
              templates={templates}
              fetchTemplates={this.getTemplates}
              getTemplatesLoading={getTemplatesLoading}
              getTemplatesError={getTemplatesError}
            />
          </TabPanel>
          <TabPanel>
            <MusicManagementContainer
              music={music}
              fetchMusic={this.getMusic}
              getMusicLoading={getMusicLoading}
              getMusicError={getMusicError}
              getInstituteLoading={getInstituteLoading}
              institutes={institutes}
            />
          </TabPanel>
          <TabPanel>
            <ParticipantManagementContainer />
          </TabPanel>
          <TabPanel>
            <ChapterManagementContainer />
          </TabPanel>
          <TabPanel>
            <JobManagementContainer afterEffectsTemplates={templates} afterEffectsMusic={music} />
          </TabPanel>
        </Tabs>
      </>
    );
  };
}

const mapDispatchToProps = (dispatch: Function) => ({
  getAzureSasData: (templateId: string, fileName: string) => dispatch(getAzureSas(templateId, fileName)),
  getAfterEffectsTemplates: () => dispatch(getAfterEffectsClipTemplates()),
  getAfterEffectsMusic: () => dispatch(getAfterEffectsMusicFiles()),
  getInstitutes: () => dispatch(getAfterEffectsInstitutions()),
});

const mapStateToProps = (state: ClippingPlatformState) => baseMapStateToProps(state);

export const ClipGeneratorPageContainer = connect(mapStateToProps, mapDispatchToProps)(ClipGeneratorPage);
